import { api } from '../api';
import { AlertsSummary } from '../../entities/Alert';
import AlertOriginEnum from '../../enums/AlertOriginEnum';
import AlertSituationEnum from '../../enums/AlertSituationEnum';

/**
 * ⚠️ **Lança o erro em vez de devolver contadores zerados.** "0 graves" é uma
 * resposta, e uma consulta que falhou não pode se passar por ela (achado de QA de
 * 18/09): quem chama mostra a falha na tela, fixa, e não num toast que some.
 */
export const getAlertsSummary = async (params: {
  from?: string;
  to?: string;
  origin?: AlertOriginEnum;
  /** O mesmo recorte da lista, para os cartões e a tabela contarem a mesma coisa. */
  situation?: AlertSituationEnum;
}): Promise<AlertsSummary> => {
  const { data } = await api.get('/alerts/summary', { params });

  return data;
};
